export const titles = {
  dashboard: "Estadísticas",
  envios: "Envíos",
  ordenes: "Órdenes",
  direcciones: "Direcciones",
  paquetes: "Paquetes",
  cotizar: "Cotizar",
  movimientos: "Movimientos",
  integraciones: "Integraciones",
  preferencias: "Preferencias",
  logout: "Cerrar Sesión",
  destinatarios: "Destinatarios",
  estadisticas: "Estadisticas",
  cuenta: "E. de Cuenta",
  recolecciones: "Recolecciones",
  admin: "Administrador",
};

export const paqueteriasRecolecciones = [
  {label:"Fedex",value:"fedex"},
  {label:"DHL",value:"dhl"},
  {label:"Redpack",value:"redpack"},
  {label:"Sendex",value:"sendex"},
  {label:"Carssa",value:"carssa"},
  {label:"UPS",value:"ups"}
];

export const meses = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre",
};

export const paises = [
  {label:'México', value:'MX'},
  {label:'Estados Unidos', value:'US'}
];

export const estados = [
  { label: "Aguascalientes", value: "AG" },
  { label: "Baja California", value: "BC" },
  { label: "Baja California Sur", value: "BS" },
  { label: "Campeche", value: "CM" },
  { label: "Chiapas", value: "CS" },
  { label: "Chihuahua", value: "CH" },
  { label: "Ciudad de México", value: "CX" },
  { label: "Coahuila", value: "CO" },
  { label: "Colima", value: "CL" },
  { label: "Durango", value: "DG" },
  { label: "Estado de México", value: "EM" },
  { label: "Guanajuato", value: "GT" },
  { label: "Guerrero", value: "GR" },
  { label: "Hidalgo", value: "HG" },
  { label: "Jalisco", value: "JA" },
  { label: "Michoacán", value: "MI" },
  { label: "Morelos", value: "MO" },
  { label: "Nayarit", value: "NA" },
  { label: "Nuevo León", value: "NL" },
  { label: "Oaxaca", value: "OA" },
  { label: "Puebla", value: "PU" },
  { label: "Querétaro", value: "QT" },
  { label: "Quintana Roo", value: "QR" },
  { label: "San Luis Potosí", value: "SL" },
  { label: "Sinaloa", value: "SI" },
  { label: "Sonora", value: "SO" },
  { label: "Tabasco", value: "TB" },
  { label: "Tamaulipas", value: "TM" },
  { label: "Tlaxcala", value: "TL" },
  { label: "Veracruz", value: "VE" },
  { label: "Yucatán", value: "YU" },
  { label: "Zacatecas", value: "ZA" },
];

export const estadosUS = [
  {value:"AL", label:"Alabama"},
  {value:"AK", label:"Alaska"},
  {value:"AS", label:"AmericanSamoa"},
  {value:"AZ", label:"Arizona"},
  {value:"AR", label:"Arkansas"},
  {value:"CA", label:"California"},
  {value:"CO", label:"Colorado"},
  {value:"CT", label:"Connecticut"},
  {value:"DE", label:"Delaware"},
  {value:"DC", label:"DistrictofColumbia"},
  {value:"FM", label:"FederatedStatesofMicronesia"},
  {value:"FL", label:"Florida"},
  {value:"GA", label:"Georgia"},
  {value:"GU", label:"Guam"},
  {value:"HI", label:"Hawaii"},
  {value:"ID", label:"Idaho"},
  {value:"IL", label:"Illinois"},
  {value:"IN", label:"Indiana"},
  {value:"IA", label:"Iowa"},
  {value:"KS", label:"Kansas"},
  {value:"KY", label:"Kentucky"},
  {value:"LA", label:"Louisiana"},
  {value:"ME", label:"Maine"},
  {value:"MH", label:"MarshallIslands"},
  {value:"MD", label:"Maryland"},
  {value:"MA", label:"Massachusetts"},
  {value:"MI", label:"Michigan"},
  {value:"MN", label:"Minnesota"},
  {value:"MS", label:"Mississippi"},
  {value:"MO", label:"Missouri"},
  {value:"MT", label:"Montana"},
  {value:"NE", label:"Nebraska"},
  {value:"NV", label:"Nevada"},
  {value:"NH", label:"NewHampshire"},
  {value:"NJ", label:"NewJersey"},
  {value:"NM", label:"NewMexico"},
  {value:"NY", label:"NewYork"},
  {value:"NC", label:"NorthCarolina"},
  {value:"ND", label:"NorthDakota"},
  {value:"MP", label:"NorthernMarianaIslands"},
  {value:"OH", label:"Ohio"},
  {value:"OK", label:"Oklahoma"},
  {value:"OR", label:"Oregon"},
  {value:"PW", label:"Palau"},
  {value:"PA", label:"Pennsylvania"},
  {value:"PR", label:"PuertoRico"},
  {value:"RI", label:"RhodeIsland"},
  {value:"SC", label:"SouthCarolina"},
  {value:"SD", label:"SouthDakota"},
  {value:"TN", label:"Tennessee"},
  {value:"TX", label:"Texas"},
  {value:"UT", label:"Utah"},
  {value:"VT", label:"Vermont"},
  {value:"VI", label:"VirginIslands"},
  {value:"VA", label:"Virginia"},
  {value:"WA", label:"Washington"},
  {value:"WV", label:"WestVirginia"},
  {value:"WI", label:"Wisconsin"},
  {value:"WY", label:"Wyoming"}
];

export const services = {
  car: "Car",
  bike: "Bike",
  motorbike: "Motorbike",
  local_guaranteed: "Local Garantizado",
  ground: "Terrestre",
  saver: "Saver",
  same_day_bike: "Bike",
  express: "Express",
  guaranteed: "Garantizado",
  same_day_mini: "Motocarro",
};

//export const API_URL = "http://localhost:5000/api";
//export const API_URL = "https://dr-envio-backend.angelmtzdiaz.now.sh/api";
//export const API_URL = "https://dr-envio-backend.ember.now.sh/api";

export const API_URL = "https://drenvio-backend-sable.vercel.app/api"

// export const CLIENT_ID = "uy0vgAf2w4H4NfbKU30ofTwWPrXzlG5C";
// export const CLIENT_ID = "7Tb4BWexcJKjflUxfA5SH8QvnzUtI6fQ";
